import axios from "axios";

export const donwloadPdfFile = (data) => {
    return async (dispatch) => {
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/downloadreportpdf`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            responseType: 'arraybuffer',
            data: data
        };
        await axios(options)
            .then(async (res) => {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${data.ss_id}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(err => {
                console.error("GET SURVEY FORM DATA FAIL", err)
            })
    }
}